export async function getAll () {
  return await axios.get('/options/countries').then(res => res.data);
}
